import {action, makeObservable, observable} from "mobx"
import {makePersistable} from "mobx-persist-store"
import mapService, {Point, RotationChanged} from '@ui/services/MapService'
import {Coordinate} from "ol/coordinate"

export interface IMap {
	readonly isBlocksView: boolean
	readonly zoom?: number 
	readonly center?: Point
  isOSM: boolean
	setTarget(mapTarget?: HTMLDivElement): void
	zoomIn(): void
	zoomOut(): void
  toggleWorldLayer(): void
  getRotation(): number
  isAnimating(): boolean
  onRotation(callback: RotationChanged): void
  rotate(rotation: number, anchor?: Coordinate): void
}

export class Map implements IMap {
	isBlocksView: boolean = true
	zoom?: number = 0
	center?: Point = [0, 0]
  isOSM: boolean = false

  constructor() {
		mapService.addZoomChangedCallback(zoom => this.setZoom(zoom))
		mapService.addCenterChangedCallback(center => this.setCenter(center))

    makeObservable(this, {
	    isBlocksView: observable,
			zoom: observable,
			center: observable,
      isOSM: observable,
			setZoom: action,
			setCenter: action,
    })

		makePersistable(this, {
			name: 'map',
			properties: ["zoom", "center"],
			storage: window.localStorage
		})
  }

  onRotation(callback: RotationChanged): void {
    mapService.addRotationChangedCallback(callback)
  }

	setTarget(mapTarget?: HTMLDivElement) {
		// @TODO Когда нибудь получать это с сервера
		mapService.bindMap({
			mapTarget,
			viewProps: {
				extent: [31, 54, 49, 60],
				minZoom: 5,
				maxZoom: 17,
				center: this.center,
				zoom: this.zoom
			}
		})
	}

	setZoom(zoom: number): void {
		this.zoom = zoom
	}

	setCenter(point: Point): void {
		this.center = point
	}

	zoomIn(): void {
		mapService.zoomChange(1)
	}

	zoomOut(): void {
		mapService.zoomChange(-1)
	}

  toggleWorldLayer(): void {
    this.isOSM = !this.isOSM
    mapService.switchWorldLayer(this.isOSM)
  }

  getRotation(): number {
    return mapService.getRotation()
  }

  isAnimating(): boolean {
    return mapService.isAnimating()
  }

  rotate(rotation: number, anchor?: Coordinate) {
    mapService.rotate(rotation, anchor)
  }
}
